import firebase from "firebase"

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBdhgthj60YOjkBBh4nhAq0T-ygbNhaw9g",
    authDomain: "facebook-messenger-346c2.firebaseapp.com",
    projectId: "facebook-messenger-346c2",
    storageBucket: "facebook-messenger-346c2.appspot.com",
    messagingSenderId: "2514687757",
    appId: "1:2514687757:web:23d2df76b67e447dcc4244",
    measurementId: "G-W55XX1J19H"
})

const db = firebaseApp.firestore();
export default db